<template>
    <modal title-modal="Configuração de Parcelas Concomitantes" modal-large id-modal="concurrent-installments-modal">
        <template #title>Configuração de Parcelas Concomitantes</template>

        <div class="modal-body">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="form-group mb-0">
                        <label>
                            {{ `Configura como as parcelas de "${this.intermediateLabel}" se comportam quando caem no mesmo mês das "${this.regularValueLabel}":` }}
                        </label>

                        <div class="mt-1">
                            <!-- Opção 1: Permitir, sem ajustar juros/prazo -->
                            <div class="custom-control custom-radio">
                                <input type="radio"
                                       class="custom-control-input"
                                       id="config_allowed"
                                       value="allowed"
                                       v-model="config"
                                       :disabled="disableInputs">
                                <label class="custom-control-label pointer"
                                       for="config_allowed">
                                    Permitir no mesmo mês, sem ajustar juros e prazo
                                </label>
                            </div>

                            <!-- Opção 2: Não permitir, sem ajustar juros/prazo -->
                            <div class="custom-control custom-radio">
                                <input type="radio"
                                       class="custom-control-input"
                                       id="config_no_allowed_no_readjustment"
                                       value="no_allowed_no_readjustment"
                                       v-model="config"
                                       :disabled="disableInputs">
                                <label class="custom-control-label pointer"
                                       for="config_no_allowed_no_readjustment">
                                    Não permitir no mesmo mês, mas sem ajustar juros, apenas prazo
                                </label>
                            </div>

                            <!-- Opção 3: Não permitir, ajustando juros/prazo -->
                            <div class="custom-control custom-radio">
                                <input type="radio"
                                       class="custom-control-input"
                                       id="config_no_allowed_with_readjustment"
                                       value="no_allowed_with_readjustment"
                                       v-model="config"
                                       :disabled="disableInputs">
                                <label class="custom-control-label pointer"
                                       for="config_no_allowed_with_readjustment">
                                    Não permitir no mesmo mês, reajustando juros e prazo
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer" style="justify-content: space-between">
            <div>
                <h5 class="font-italic" style="font-size: .7rem; color: red">Configuração válida apenas para tabela PRICE</h5>
            </div>
            <div>
                <div class="btn btn-secondary" id="closeNJ" data-dismiss="modal" aria-label="Close"
                     @click="closeModal">{{ t('ACTIONS.CLOSE') }}</div>
                <div class="btn btn-primary ml-2" @click="save">{{ t('ACTIONS.SAVE') }}</div>
            </div>
        </div>
    </modal>
</template>

<script>

import {useI18n} from 'vue-i18n';
import modal from '@/components/modal.vue';
import {useToast} from 'vue-toastification';

export default {
    name: 'concurrentInstallmentsComponent',

    emits: ['updateConcurrentConfig'],

    setup() {
        const {t} = useI18n();
        const toast = useToast();

        return {t, toast};
    },

    props: {
        disableInputs: {
            type: Boolean,
            default: false,
        }
    },

    components: {
        modal
    },

    data() {
        return {
            config: '',
            intermediateLabel: 'Intermediárias',
            regularValueLabel: 'Parcelas Regulares',
        }
    },

    methods: {
        setConcurrentData(simulatorConfig) {
            this.config = simulatorConfig.concurrent_installment;
            this.intermediateLabel = simulatorConfig.type_installment_configs?.find(item => item.position === 3)?.label ?? 'Intermediárias';
            this.regularValueLabel = simulatorConfig.type_installment_configs?.find(item => item.position === 5)?.label ?? 'Parcelas Regulares';
        },

        closeModal() {
            document.getElementById('closeNJ')?.click();
        },

        save() {
            if (this.$route.params.action !== 'adicionar') {
                this.$swal.fire({
                    title: 'Tem Certeza?',
                    text: 'Esta ação é irreversível',
                    icon: 'question',
                    showCancelButton: true,
                    showCloseButton: false,
                    confirmButtonText: 'Atualizar',
                    cancelButtonText: 'Cancelar',
                }).then(result => {
                    if (result.isConfirmed) this.$emit('updateConcurrentConfig', this.config);
                });
            } else this.$emit('updateConcurrentConfig', this.config);
        }
    }
};

</script>
